import React from 'react';

const word = (props) => {
    return (
        <div className="col-sm-3">
            {props.word}
        </div>
    );
}

export default word;